module.exports = __webpack_public_path__ + "static/media/kiss-available-usa.dabdb36b.png";